import { signOut } from "entities/auth/api";
import { useAuthUserStore } from "entities/auth/stores/authUserStore";
import { useUserRoleStore } from "entities/auth/stores/userRoleStore";
import { FC, ReactNode } from "react";
import RoleChip from "shared/components/RoleChip";
import { LogOutIcon } from "shared/theme/icons/LogOutIcon";
import Header from "./components/Header";
import Separator from "./components/Separator";
import User from "./components/User";
import {
  StyledChipsWrapper,
  StyledContent,
  StyledMenuBar,
  StyledMenuBarContainer,
} from "./styled";

type MenuBarProps = {
  children: ReactNode;
  isMenuBarExpanded: boolean;
  isHovered: boolean;
  toggleMenuBar: () => void;
};

const MenuBar: FC<MenuBarProps> = (props) => {
  const { firebaseUser } = useAuthUserStore();
  const userEmail = firebaseUser ? firebaseUser?.email || "" : undefined;
  const { roles } = useUserRoleStore();
  const isExpanded = props.isMenuBarExpanded || props.isHovered;

  return (
    <StyledMenuBarContainer
      expanded={props.isMenuBarExpanded}
      isHovered={props.isHovered}
    >
      <StyledMenuBar expanded={isExpanded}>
        <Header
          isHovered={props.isHovered}
          isMenuBarExpanded={props.isMenuBarExpanded}
          toggleMenuBar={props.toggleMenuBar}
        />
        <StyledContent>{props.children}</StyledContent>
        <Separator />
        {isExpanded && (
          <StyledChipsWrapper>
            {roles.map((role) => (
              <RoleChip key={`${userEmail}-${role}`} title={role} />
            ))}
          </StyledChipsWrapper>
        )}
        <User
          isExpanded={isExpanded}
          subtitle={userEmail}
          dropdown={[
            { title: "Logout", style: "remove", onClick: () => signOut() },
          ]}
          dropdownIcon={<LogOutIcon />}
        />
      </StyledMenuBar>
    </StyledMenuBarContainer>
  );
};

export default MenuBar;
